import { Model } from "./model";

export class PostComment extends Model {
    id: number;
    post_id: number;
    user_id: number
    title: string;
    content: string;
    status: string;
    user_firstname: string;
    user_lastname: string;
    created: string;
    modified: string;
}


// WEBPACK FOOTER //
// ./src/models/post-comment.model.ts